import * as moment from "moment";

export class DateParser {
  static dayMonth(timestamp: string) {
    moment.locale("es-mx");
    return moment.utc(timestamp);
  }

  static roundUpHour(timestamp: string) {
    const m = moment.utc(timestamp);
    const roundUp = m.minute() || m.second() || m.millisecond() ? m.add(1, "hour").startOf("hour") : m.startOf("hour");
    m.locale("es-mx");
    return roundUp;
  }

  static genericFormat(timestamp: string) {
    const m = moment(timestamp);
    m.locale("es-mx");
    return m;
  }
}

/**
 * Returns the UTC offset (e.g. "-0300") that an IANA time zone such as "America/Sao_Paulo" has at the given instant,
 * in the format Angular's DatePipe accepts as its `timezone` argument. DatePipe itself cannot parse IANA names
 * (it falls back to the browser's local zone), so this bridges the gap. Returns undefined for invalid input.
 */
export function timezoneOffset(date: Date, timeZone: string): string | undefined {
  if (!timeZone || isNaN(date.getTime())) return undefined;
  try {
    const parts = new Intl.DateTimeFormat("en-US", {
      timeZone,
      hourCycle: "h23",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    }).formatToParts(date);
    const read = (type: string) => Number(parts.find(p => p.type === type)?.value);
    const wallClockAsUtc = Date.UTC(read("year"), read("month") - 1, read("day"), read("hour") % 24, read("minute"), read("second"));
    const instant = Math.floor(date.getTime() / 1000) * 1000;
    const offsetMinutes = Math.round((wallClockAsUtc - instant) / 60000);
    const sign = offsetMinutes < 0 ? "-" : "+";
    const abs = Math.abs(offsetMinutes);
    return `${sign}${String(Math.floor(abs / 60)).padStart(2, "0")}${String(abs % 60).padStart(2, "0")}`;
  } catch {
    return undefined;
  }
}
